import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import IconButton from '@mui/material/IconButton';
import '../assets/styles/Footer.scss'

function Footer({ mode, modeChange }: any) {
  return (
    <footer>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px', flexWrap: 'wrap' }}>
        <div>
          <a href="https://github.com/TrevorBushnell" target="_blank" rel="noreferrer"><GitHubIcon/></a>
          <a href="https://www.linkedin.com/in/trevor-bushnell/" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        </div>
        {modeChange && (
          <IconButton color="inherit" onClick={modeChange} aria-label="toggle light/dark mode" sx={{ ml: 2 }}>
            {mode === 'dark' ? <LightModeIcon /> : <DarkModeIcon />}
          </IconButton>
        )}
      </div>
    </footer>
  );
}

export default Footer;